<div class="p-4">
    <h3 class="mb-2">Decline this cash out?</h3>
    <p class="sub-text">No funds move. The voucher stays active and the customer can redeem it with another agent until it expires.</p>

    <div class="reason-list my-4" role="radiogroup" aria-label="Decline reason">
        <label class="reason-card" *ngFor="let reason of reasons" [class.selected]="reasonControl.value === reason">
            <input type="radio" name="declineReason" [value]="reason" [formControl]="reasonControl" />
            <span>{{ reason }}</span>
        </label>

        <textarea class="other-reason-input" *ngIf="isOtherSelected" rows="3" placeholder="Enter the reason..." [formControl]="otherReasonTextControl"></textarea>
    </div>

    <div class="d-flex gap-2">
        <button mat-stroked-button color="primary" class="rounded-pill flex-fill back-btn" (click)="back()">Back</button>
        <button mat-flat-button class="rounded-pill flex-fill decline-btn" [disabled]="isOtherSelected && !otherReasonTextControl.value?.trim()" (click)="decline()">
            Decline
        </button>
    </div>
</div>
